import React from 'react';

import { CardContainer } from './CategoryCard.styled';

interface Props {
  label: string;
  icon?: JSX.Element;
  onClick: () => void;
}

export const CategoryCard = ({ label, icon, onClick }: Props): JSX.Element => (
  <CardContainer onClick={onClick} type="button">
    {icon && <div className="icon-container">{icon}</div>}
    <div className="label">{label}</div>
  </CardContainer>
);
